import { apiUrl } from 'util/apiUrl';
import { Error } from 'models/Error';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { OrganizationResponseModelPaginatedList } from 'types/api';
import {
  ContentType,
  useAuthenticatedFetch,
} from 'hooks/util/useAuthenticatedFetch';

export const useOrganizationList = (
  removeOrganizationHeader = false,
  enabled = true,
  { page = 1 },
) => {
  const fetch = useAuthenticatedFetch(
    removeOrganizationHeader
      ? ContentType.NO_ORGANIZATION_HEADER
      : ContentType.APPLICATIONJSON,
  );
  return useQuery<OrganizationResponseModelPaginatedList, Error>(
    ['organizationList', { page }],
    () =>
      fetch(
        `${apiUrl}/Organizations?pageIndex=${page}`,
      ),
    {
      enabled,
      keepPreviousData: true,
      onError: () => {
        toast.error('Error fetching organizations.');
      },
    },
  );
};
